import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";

function NoFormsAvailablePage({ t }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 250);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={isVisible ? "my-forms-visible layout h-full overflow-x-hidden" : "hidden"}>
            <div className="flex flex-col items-center justify-center h-[60vh] text-center max-w-md mx-auto">
                <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                    style={{
                        backgroundColor: "color-mix(in srgb, var(--primary-color) 10%, white)",
                    }}
                >
                    <CalendarDaysIcon
                        className="h-8 w-8"
                        style={{ color: "var(--primary-color)" }}
                    />
                </div>

                <h1 className="text-2xl font-bold text-gray-900 mb-3">
                    {t("Aucune formation disponible")}
                </h1>
                <p className="text-gray-500 text-sm leading-relaxed">
                    {t("Il n'y a pas de formulaire de candidature disponible pour le moment. Revenez bientôt, de nouvelles formations seront prochainement ouvertes.")}
                </p>

                {/* <div
                    className="mt-8 rounded-2xl border p-5 w-full text-left"
                    style={{
                        borderColor: "color-mix(in srgb, var(--primary-color) 20%, white)",
                        background: "linear-gradient(135deg, color-mix(in srgb, var(--primary-color) 5%, white), white)",
                    }}
                >
                    <p className="text-xs font-semibold color-primary-perso tracking-widest uppercase mb-2">
                        {t("En attendant")}
                    </p>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        {t("Complétez votre profil dès maintenant pour être prêt dès l'ouverture des candidatures.")}
                    </p>
                    <button
                        // Accès direct au profil pour préparer les futures candidatures.
                        onClick={() => window.location.href = "/profile"}
                        className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-sm font-semibold transition-opacity hover:opacity-90"
                        style={{ backgroundColor: "var(--primary-color)" }}
                    >
                        {t("Compléter mon profil")}
                    </button>
                </div> */}
            </div>
        </div>
    );
}
export default withTranslation()(NoFormsAvailablePage);
